<template>
  <lw-overlay
    :size="'c1'"
    :colour="'cream'"
  >
    <div class="grid grid-columns-4_md">
      <div class="grid-column-start-2_md grid-column-end-4_md flex flex-column justify-items-center vh75">
        <h1 class="mb2">Create an estimate</h1>
        <form @submit.prevent="addEstimate">
          <fieldset>
            <lw-text-input
              v-validate="'required'"
              :name="'project'"
              :label="'Project name'"
              :size="'large'"
              v-model="project"
              :error="errors.first('project')"
            />
            <lw-text-input
              v-validate="'required'"
              :name="'client'"
              :label="'Client name'"
              :size="'large'"
              v-model="client"
              :error="errors.first('client')"
            />
            <lw-text-area
              :name="'description'"
              :label="'Description'"
              :size="'large'"
              :optional="true"
              v-model="description"
            />
            <lw-button-group
              :name="'rateType'"
              :current="rateType"
              :label="'Estimating unit'"
              :options="rates"
              v-model="rateType"
            />
            <lw-select-input
              v-if="rateList.length"
              :label="'Choose a rate card'"
              :name="'rateCard'"
              :id="'rateCard'"
              :size="'large'"
              :class="'mb2'"
              :options="rateList"
              :placeholder="'Don’t use a rate card'"
              v-model="rateCard"
            />
            <div
              v-if="!rateList.length || rateCard === 'zzzzz'"
              class="flex align-items-center mb1">
              <lw-currency-input
                :label="'Set your rate'"
                :name="'rateValue'"
                :type="'number'"
                :size="'large'"
                :align="'right'"
                :class="'pr1 mb2'"
                :currency="organization.currency"
                v-model.number="rateValue"
              />
              <span class="font-size-3 block align-right">/{{ rates[rateType].label | lowercase }}</span>
            </div>
            <div class="flex justify-content-space-between mb4">
              <button
                class="invisible-button negative-button"
                @click.prevent="cancel">Cancel</button>
              <button
                type="submit"
                name="submit"
                class="large-button accent-button mr1">Create your estimate</button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </lw-overlay>
</template>

<script>
import { mapGetters } from 'vuex'
import * as firebase from 'firebase'
import Overlay from '../livewires/Overlay'
import TextInput from '../livewires/TextInput'
import TextArea from '../livewires/TextArea'
import CurrencyInput from '../livewires/CurrencyInput'
import SelectInput from '../livewires/SelectInput'
import ButtonGroup from '../livewires/ButtonGroup'

export default {
  components: {
    lwTextInput: TextInput,
    lwTextArea: TextArea,
    lwCurrencyInput: CurrencyInput,
    lwSelectInput: SelectInput,
    lwOverlay: Overlay,
    lwButtonGroup: ButtonGroup
  },
  data () {
    return {
      project: '',
      client: '',
      description: '',
      rateCard: 'zzzzz',
      rateValue: '',
      rateType: 1
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'organization',
      'estimates',
      'rateList'
    ]),
    loaded () {
      return this.$store.getters.ratesLoading
    },
    rates () {
      return [
        { label: 'Hour', value: 0 },
        { label: 'Day', value: 1 },
        { label: 'Week', value: 2 },
        { label: 'Sprint', value: 3 },
        { label: 'Month', value: 4 }
      ]
    }
  },
  methods: {
    addEstimate () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const updated = firebase.default.firestore.FieldValue.serverTimestamp()
          this.$store.dispatch('saveState', false)
          let rateCard = false
          if (this.rateCard) {
            rateCard = this.rateCard
          }
          const payload = {
            project: this.project,
            client: this.client,
            description: this.description,
            rateCard: rateCard,
            lastRateCard: false,
            organization: this.organization.id,
            owner: this.user.id,
            created: updated,
            updated: updated,
            rateType: this.rateType,
            rateValue: this.rateValue,
            lowPrice: 0,
            midPrice: 0,
            highPrice: 0,
            lowTime: 0,
            midTime: 0,
            highTime: 0,
            lowMidPrice: 0,
            lowMidTime: 0,
            midHighPrice: 0,
            midHighTime: 0,
            projectManagement: 1.15,
            roles: false,
            team: false,
            redFlags: false,
            tasks: false,
            showRedFlags: false,
            showTeamBreakdown: false,
            showRoleBreakdown: false,
            archived: false
          }
          this.$store.dispatch('addEstimate', payload).then(response => {
            this.$router.push({ name: 'estimate', params: { id: response }, query: { s: '1' } })
          })
        }
      })
    },
    cancel () {
      this.$router.go(-1)
    }
  }
}
</script>
